import React from "react";

const RemovePenaltyIcon = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            fill={fill}
            d="M10.527 15.682A7.39 7.39 0 0 0 5.9 13.11a5.597 5.597 0 0 1-2.574-1.738 5.742 5.742 0 0 1 .693-8.04 5.677 5.677 0 0 1 9.305 3.822 7.32 7.32 0 0 0 4.863 6.934l-6.06 5.094a7.178 7.178 0 0 0-1.6-3.499ZM34 31.334H9.247V34H34v-2.667Zm-22.663-2.574 16.582-13.93-2.752-3.076L8.585 25.688l2.752 3.071Z"
        />
        <path className="u_fill" fill={fill} d="M14 32a4 4 0 0 1 4-4h9a4 4 0 0 1 4 4H14Z" />
    </svg>
);

export default RemovePenaltyIcon;